import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePeriscopeNextGenRoute: InvariantJiraRoute = {
	name: 'software-periscope',
	path: '/jira/software/projects/:projectKey/development',
};
